import { render, staticRenderFns } from "./OwnershipCreateForm.vue?vue&type=template&id=7cf98a5b&"
import script from "./OwnershipCreateForm.vue?vue&type=script&lang=js&"
export * from "./OwnershipCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports